import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizState } from ".";
import { ITicketsBalances } from "../../model/user-info.interface";
import { getTasks } from "../tasks/get-tasks.handler";

export interface IFinishQuizResponse {
    tickets: ITicketsBalances;
    exp: number;
};

export const finishQuiz = createAsyncThunk<IFinishQuizResponse>(
    'quiz.finishQuiz',
    async (_, { dispatch }) => {
        const result = await api.quizzes.finish();
        dispatch(getTasks());
        return result;
    }
);

const finishQuizHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(finishQuiz.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(finishQuiz.fulfilled, (state: IQuizState) => {
            state.loading = false;            
            state.quiz = null;
            state.answerResult = null;
            state.isExpired = false;
        })
        .addCase(finishQuiz.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to finish quiz';
        });
};

export default finishQuizHandler;
